import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLock, FiLogIn, FiEye, FiEyeOff } = FiIcons;

// Get admin password from localStorage or use default
const getAdminPassword = () => {
  return localStorage.getItem('adminPassword') || 'admin123';
};

const AdminLogin = ({ onLoginSuccess }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = () => {
    setIsLoading(true);
    setError('');

    // Simulate API call with timeout
    setTimeout(() => {
      const currentAdminPassword = getAdminPassword();
      if (password === currentAdminPassword) {
        localStorage.setItem('adminAuthenticated', 'true');
        onLoginSuccess();
      } else {
        setError('Incorrect password. Please try again.');
      }
      setIsLoading(false);
    }, 800);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full bg-white/10 backdrop-blur-lg p-8 rounded-3xl"
      >
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-purple-500/30 rounded-full mb-4">
            <SafeIcon icon={FiLock} className="text-4xl text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white">Admin Login</h1>
          <p className="text-pink-200 mt-2">Enter your password to access admin controls</p>
        </div>

        <div className="space-y-6">
          <div>
            <label className="block text-pink-200 text-sm font-bold mb-2">
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleLogin()}
                className="w-full p-4 pr-10 rounded-xl bg-white/10 text-white placeholder-pink-200 border border-pink-300/30 focus:border-pink-400 focus:outline-none"
                placeholder="Enter admin password"
              />
              <button
                type="button"
                onClick={togglePasswordVisibility}
                className="absolute inset-y-0 right-0 pr-3 flex items-center text-pink-300 hover:text-pink-100"
              >
                <SafeIcon icon={showPassword ? FiEyeOff : FiEye} className="text-xl" />
              </button>
            </div>
            {error && (
              <p className="text-red-400 text-sm mt-2">{error}</p>
            )}
          </div>

          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleLogin}
            disabled={isLoading || !password}
            className="w-full bg-gradient-to-r from-purple-500 to-blue-500 hover:from-purple-600 hover:to-blue-600 disabled:from-gray-400 disabled:to-gray-500 disabled:cursor-not-allowed text-white font-bold py-4 px-6 rounded-xl shadow-lg transition-all duration-300 flex items-center justify-center gap-2"
          >
            {isLoading ? (
              <div className="w-6 h-6 border-t-2 border-white rounded-full animate-spin"></div>
            ) : (
              <>
                <SafeIcon icon={FiLogIn} className="text-xl" />
                Login
              </>
            )}
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
};

export default AdminLogin;